import React, { useContext } from 'react';
import { PermissionContext, RolePermissions } from '../../../../../../appContext';
import { pages } from '../../../common/constant';
import { PermisionDenied } from '../../../common/commonComponents';
import StudentSearchAndListing from './StudentSearchAndListing';

const CentralizedStudentOtherCharges = () => {

    const userPermissions = RolePermissions(useContext(PermissionContext), pages["centralizedOtherCharges"]["id"]);

    return (
        userPermissions
            ? <StudentSearchAndListing />
            : <PermisionDenied />
    );
}

export default CentralizedStudentOtherCharges;